import React from 'react';

const PropertyDetails = ({ details }) => {
    const detailEntries = Object.entries(details);
    const firstDetail = detailEntries[0];
    const secondDetail = detailEntries[1]; // Safeguard added below
    const showSecondDetail = firstDetail && secondDetail && 
        firstDetail[1]?.label?.length + secondDetail[1]?.label?.length <= 20;

    return (
        <div className="product-details w-100">
            <ul className="d-flex flex-wrap text-gray-700 list-unstyled m-0 w-100" style={{ maxHeight: '4rem', overflow: 'hidden', rowGap: '0.3rem', columnGap: '1rem' }}>
                {firstDetail && (
                    <li key={firstDetail[0]} className="d-flex align-items-center m-0" style={{ flex: '1 0 calc(50% - 1rem)', whiteSpace: 'nowrap', overflow: 'hidden', textOverflow: 'ellipsis' }}>
                        <i className={`${firstDetail[1]?.attribute} me-2`}></i>
                        <span style={{ textOverflow: 'ellipsis', overflow: 'hidden', whiteSpace: 'nowrap' }}>{firstDetail[1].label}</span>
                    </li>
                )}
                {showSecondDetail && secondDetail && (
                    <li key={secondDetail[0]} className="d-flex align-items-center m-0" style={{ flex: '1 0 calc(50% - 1rem)', whiteSpace: 'nowrap', overflow: 'hidden', textOverflow: 'ellipsis' }}>
                        <i className={`${secondDetail[1]?.attribute} me-2`}></i>
                        <span style={{ textOverflow: 'ellipsis', overflow: 'hidden', whiteSpace: 'nowrap' }}>{secondDetail[1].label}</span>
                    </li>
                )}
            </ul>
        </div>
    );
};

export default PropertyDetails;